@use 'src/globals/main';

pn-accordion {
  position: relative;
  background-color: main.$white;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: 0.25em;

  &[data-transparent] {
    background-color: transparent;
  }
  > pn-accordion-row + pn-accordion-row:after {
    content: '';
    position: absolute;
    top: -0.125em;
    left: 0.25em;
    width: calc(100% - 0.5em);
    height: 0;
    border-top: main.$onepixel solid main.$gray200;
  }
}
